import {dataTestId} from '@hproduce/suite-core'
import {CalendarToday} from '@mui/icons-material'
import {Slider, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import type {OptimizerSettings} from '../../types'

interface OptimizerSettingsHorizonSliderProps {
  optimizerSettings: OptimizerSettings
  value: number
  setValue: (value: number) => void
}

export const OptimizerSettingsHorizonSlider: React.FC<OptimizerSettingsHorizonSliderProps> = ({
  optimizerSettings: {maxHorizonDays, expectedDurations},
  value,
  setValue
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const minHorizonDays = 1

  const marks = [
    {
      value: minHorizonDays,
      label: minHorizonDays.toString()
    },
    {
      value: value,
      label: value.toString()
    },
    {
      value: maxHorizonDays,
      label: maxHorizonDays.toString()
    }
  ]

  const expectedDuration = expectedDurations[value.toString()]

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" spacing={1}>
          <CalendarToday />
          <Typography {...dataTestId('horizon_slider_title')}>
            {t('optimizer.optimizerHorizon')}
          </Typography>
        </Stack>
        <Typography {...dataTestId('horizon_slider_expected_duration')}>
          {t('optimizer.expectedDuration', expectedDuration)}
        </Typography>
      </Stack>
      <Slider
        min={minHorizonDays}
        max={maxHorizonDays}
        value={value}
        marks={marks}
        aria-label="Horizon"
        onChange={(_, newValue) => setValue(newValue as number)}
        sx={({palette, spacing}) => ({
          color: palette.common.black,
          '& .MuiSlider-thumb': {
            width: spacing(3),
            height: spacing(3),
            border: `3px solid ${palette.common.white}`,
            boxShadow: 5
          },
          '& .MuiSlider-rail': {
            opacity: 0.5,
            color: palette.grey[400]
          },
          '& .MuiSlider-markLabel': {
            fontSize: spacing(2)
          }
        })}
        {...dataTestId('horizon_slider')}
      />
    </Stack>
  )
}
